var map = {
	"./pbi_ancora_16.svg": 57826,
	"./pbi_ancora_24.svg": 1238,
	"./pbi_ancora_32.svg": 738,
	"./pbi_assinaturas_alterar_16.svg": 15535,
	"./pbi_assinaturas_alterar_24.svg": 32076,
	"./pbi_assinaturas_alterar_32.svg": 79742,
	"./pbi_assinaturas_ativas_16.svg": 73250,
	"./pbi_assinaturas_ativas_24.svg": 48868,
	"./pbi_assinaturas_ativas_32.svg": 84252,
	"./pbi_assinaturas_canceladas_16.svg": 29754,
	"./pbi_assinaturas_canceladas_24.svg": 71253,
	"./pbi_assinaturas_canceladas_32.svg": 94745,
	"./pbi_bag_plus_24.svg": 26403,
	"./pbi_bank_16.svg": 27680,
	"./pbi_bank_24.svg": 46039,
	"./pbi_bank_32.svg": 59073,
	"./pbi_boleto_16.svg": 76088,
	"./pbi_boleto_24.svg": 880,
	"./pbi_boleto_32.svg": 4602,
	"./pbi_box_16.svg": 77419,
	"./pbi_box_24.svg": 31618,
	"./pbi_box_32.svg": 73517,
	"./pbi_busca_16.svg": 20824,
	"./pbi_busca_24.svg": 97774,
	"./pbi_busca_32.svg": 6288,
	"./pbi_calendario_16.svg": 72784,
	"./pbi_calendario_24.svg": 2555,
	"./pbi_calendario_32.svg": 36658,
	"./pbi_calendario_ok_16.svg": 34338,
	"./pbi_calendario_ok_24.svg": 10738,
	"./pbi_calendario_ok_32.svg": 88389,
	"./pbi_categoria_16.svg": 92134,
	"./pbi_categoria_24.svg": 38977,
	"./pbi_categoria_32.svg": 88421,
	"./pbi_check_16.svg": 8080,
	"./pbi_check_24.svg": 16781,
	"./pbi_check_32.svg": 21839,
	"./pbi_code_16.svg": 11409,
	"./pbi_code_24.svg": 83512,
	"./pbi_code_32.svg": 84413,
	"./pbi_coin_16.svg": 79898,
	"./pbi_coin_24.svg": 37640,
	"./pbi_coin_32.svg": 93489,
	"./pbi_conexoes_16.svg": 2622,
	"./pbi_conexoes_24.svg": 87013,
	"./pbi_conexoes_32.svg": 40333,
	"./pbi_config_message_16.svg": 39331,
	"./pbi_config_message_24.svg": 80164,
	"./pbi_config_message_32.svg": 38694,
	"./pbi_copy_16.svg": 56196,
	"./pbi_copy_24.svg": 8745,
	"./pbi_copy_32.svg": 58399,
	"./pbi_credit_card_16.svg": 35253,
	"./pbi_credit_card_24.svg": 30249,
	"./pbi_credit_card_32.svg": 7592,
	"./pbi_dashboard_16.svg": 82370,
	"./pbi_dashboard_24.svg": 4049,
	"./pbi_dashboard_32.svg": 26184,
	"./pbi_dashboard_config_16.svg": 70587,
	"./pbi_dashboard_config_24.svg": 19052,
	"./pbi_dashboard_config_32.svg": 59521,
	"./pbi_dashboard_list_16.svg": 32086,
	"./pbi_dashboard_list_24.svg": 45184,
	"./pbi_dashboard_list_2_16.svg": 22654,
	"./pbi_dashboard_list_2_24.svg": 69543,
	"./pbi_dashboard_list_2_32.svg": 55131,
	"./pbi_dashboard_list_32.svg": 11104,
	"./pbi_data_especial_16.svg": 47809,
	"./pbi_data_especial_24.svg": 75465,
	"./pbi_data_especial_32.svg": 89380,
	"./pbi_debit_card_16.svg": 84492,
	"./pbi_debit_card_24.svg": 88530,
	"./pbi_debit_card_32.svg": 13509,
	"./pbi_desconto_16.svg": 26965,
	"./pbi_desconto_24.svg": 6071,
	"./pbi_desconto_32.svg": 72399,
	"./pbi_download_16.svg": 20439,
	"./pbi_download_24.svg": 8018,
	"./pbi_download_32.svg": 72104,
	"./pbi_editar_16.svg": 56637,
	"./pbi_editar_24.svg": 71848,
	"./pbi_editar_32.svg": 64285,
	"./pbi_email_16.svg": 56177,
	"./pbi_email_24.svg": 24925,
	"./pbi_email_32.svg": 67545,
	"./pbi_error_16.svg": 95301,
	"./pbi_error_24.svg": 63066,
	"./pbi_error_32.svg": 21414,
	"./pbi_extrato_16.svg": 7707,
	"./pbi_extrato_24.svg": 71587,
	"./pbi_extrato_32.svg": 24315,
	"./pbi_facebook_16.svg": 22447,
	"./pbi_facebook_24.svg": 52122,
	"./pbi_facebook_32.svg": 67286,
	"./pbi_favorito_16.svg": 81297,
	"./pbi_favorito_24.svg": 63249,
	"./pbi_favorito_32.svg": 40892,
	"./pbi_fechar_16.svg": 63159,
	"./pbi_fechar_24.svg": 30592,
	"./pbi_fechar_32.svg": 63036,
	"./pbi_filtro_16.svg": 43292,
	"./pbi_filtro_24.svg": 58172,
	"./pbi_filtro_32.svg": 1389,
	"./pbi_frete_16.svg": 73767,
	"./pbi_frete_24.svg": 41474,
	"./pbi_frete_32.svg": 11792,
	"./pbi_grid_16.svg": 42871,
	"./pbi_info_16.svg": 79087,
	"./pbi_info_24.svg": 9289,
	"./pbi_info_32.svg": 11340,
	"./pbi_instagram_16.svg": 18060,
	"./pbi_instagram_24.svg": 92190,
	"./pbi_instagram_32.svg": 92180,
	"./pbi_integration_16.svg": 60227,
	"./pbi_integration_24.svg": 86016,
	"./pbi_integration_32.svg": 5863,
	"./pbi_lamp_16.svg": 89939,
	"./pbi_lamp_24.svg": 61101,
	"./pbi_lamp_32.svg": 25205,
	"./pbi_language_16.svg": 22844,
	"./pbi_language_24.svg": 68775,
	"./pbi_language_32.svg": 67055,
	"./pbi_link_16.svg": 58390,
	"./pbi_link_24.svg": 60393,
	"./pbi_link_2_16.svg": 43965,
	"./pbi_link_2_24.svg": 48242,
	"./pbi_link_2_32.svg": 81349,
	"./pbi_link_32.svg": 17033,
	"./pbi_linkedin_16.svg": 64411,
	"./pbi_linkedin_24.svg": 62661,
	"./pbi_linkedin_32.svg": 12847,
	"./pbi_list_16.svg": 34051,
	"./pbi_lista_16.svg": 51222,
	"./pbi_lista_24.svg": 62067,
	"./pbi_lista_32.svg": 79943,
	"./pbi_livro_16.svg": 37068,
	"./pbi_livro_24.svg": 28322,
	"./pbi_livro_32.svg": 63860,
	"./pbi_loader_money_16.svg": 39352,
	"./pbi_loader_money_24.svg": 69676,
	"./pbi_loader_money_32.svg": 37836,
	"./pbi_mais_16.svg": 50917,
	"./pbi_mais_24.svg": 31031,
	"./pbi_mais_32.svg": 91141,
	"./pbi_menos_16.svg": 35184,
	"./pbi_menos_24.svg": 9646,
	"./pbi_menos_32.svg": 62430,
	"./pbi_menu_1_16.svg": 83879,
	"./pbi_menu_1_24.svg": 15953,
	"./pbi_menu_1_32.svg": 46801,
	"./pbi_menu_2_16.svg": 99985,
	"./pbi_menu_2_24.svg": 65881,
	"./pbi_menu_2_32.svg": 34504,
	"./pbi_menu_3_16.svg": 31812,
	"./pbi_menu_3_24.svg": 22,
	"./pbi_menu_3_32.svg": 589,
	"./pbi_more_16.svg": 19725,
	"./pbi_more_24.svg": 91130,
	"./pbi_more_32.svg": 36166,
	"./pbi_new_tab_16.svg": 43304,
	"./pbi_new_tab_24.svg": 30770,
	"./pbi_new_tab_32.svg": 95662,
	"./pbi_next_16.svg": 3505,
	"./pbi_next_24.svg": 37289,
	"./pbi_next_32.svg": 59511,
	"./pbi_no_photo_16.svg": 7435,
	"./pbi_no_photo_24.svg": 95200,
	"./pbi_no_photo_32.svg": 53184,
	"./pbi_nuvem_16.svg": 73102,
	"./pbi_nuvem_24.svg": 60101,
	"./pbi_nuvem_32.svg": 60975,
	"./pbi_one_clique_16.svg": 41198,
	"./pbi_one_clique_24.svg": 40673,
	"./pbi_one_clique_32.svg": 29081,
	"./pbi_pause_16.svg": 79323,
	"./pbi_pause_24.svg": 53370,
	"./pbi_pause_32.svg": 61444,
	"./pbi_payment_link_24.svg": 44857,
	"./pbi_personalizacao_16.svg": 72918,
	"./pbi_personalizacao_24.svg": 64775,
	"./pbi_personalizacao_32.svg": 3020,
	"./pbi_pix_16.svg": 55305,
	"./pbi_pix_24.svg": 24208,
	"./pbi_pix_32.svg": 27212,
	"./pbi_play_16.svg": 75200,
	"./pbi_play_24.svg": 2778,
	"./pbi_play_32.svg": 79266,
	"./pbi_prev_16.svg": 801,
	"./pbi_prev_24.svg": 32631,
	"./pbi_prev_32.svg": 55360,
	"./pbi_qr_code_16.svg": 67385,
	"./pbi_qr_code_24.svg": 79911,
	"./pbi_qr_code_32.svg": 91020,
	"./pbi_recorrencia_16.svg": 49794,
	"./pbi_recorrencia_24.svg": 96061,
	"./pbi_recorrencia_32.svg": 76270,
	"./pbi_relogio_16.svg": 6876,
	"./pbi_relogio_24.svg": 13678,
	"./pbi_relogio_32.svg": 9333,
	"./pbi_send_16.svg": 43382,
	"./pbi_send_24.svg": 47906,
	"./pbi_send_32.svg": 92977,
	"./pbi_seta_direita_16.svg": 67459,
	"./pbi_seta_direita_24.svg": 51627,
	"./pbi_seta_direita_32.svg": 22621,
	"./pbi_seta_esquerda_16.svg": 65759,
	"./pbi_seta_esquerda_24.svg": 6884,
	"./pbi_seta_esquerda_32.svg": 21015,
	"./pbi_seta_para_baixo_16.svg": 30776,
	"./pbi_seta_para_baixo_24.svg": 14765,
	"./pbi_seta_para_baixo_32.svg": 51037,
	"./pbi_seta_para_cima_16.svg": 54496,
	"./pbi_seta_para_cima_24.svg": 84985,
	"./pbi_seta_para_cima_32.svg": 58656,
	"./pbi_seta_simples_direita_16.svg": 49751,
	"./pbi_seta_simples_direita_24.svg": 46808,
	"./pbi_seta_simples_direita_32.svg": 83109,
	"./pbi_seta_simples_esquerda_16.svg": 9831,
	"./pbi_seta_simples_esquerda_24.svg": 68835,
	"./pbi_seta_simples_esquerda_32.svg": 39060,
	"./pbi_seta_simples_para_baixo_16.svg": 22942,
	"./pbi_seta_simples_para_baixo_24.svg": 1570,
	"./pbi_seta_simples_para_baixo_32.svg": 35470,
	"./pbi_seta_simples_para_cima_16.svg": 42064,
	"./pbi_seta_simples_para_cima_24.svg": 70531,
	"./pbi_seta_simples_para_cima_32.svg": 9735,
	"./pbi_settings_16.svg": 8767,
	"./pbi_settings_24.svg": 77002,
	"./pbi_settings_32.svg": 5277,
	"./pbi_share_16.svg": 30895,
	"./pbi_share_24.svg": 59611,
	"./pbi_share_32.svg": 63442,
	"./pbi_site_desk_16.svg": 99254,
	"./pbi_site_desk_24.svg": 13899,
	"./pbi_site_desk_32.svg": 86045,
	"./pbi_star_16.svg": 67151,
	"./pbi_star_24.svg": 18911,
	"./pbi_star_32.svg": 55252,
	"./pbi_star_fill_24.svg": 88822,
	"./pbi_store_16.svg": 82480,
	"./pbi_store_24.svg": 55739,
	"./pbi_store_32.svg": 8950,
	"./pbi_streaming_16.svg": 90615,
	"./pbi_streaming_24.svg": 12408,
	"./pbi_streaming_32.svg": 14418,
	"./pbi_tempo_16.svg": 92971,
	"./pbi_tempo_24.svg": 25932,
	"./pbi_tempo_32.svg": 18560,
	"./pbi_toga_16.svg": 2816,
	"./pbi_toga_24.svg": 15356,
	"./pbi_toga_32.svg": 59784,
	"./pbi_trash_16.svg": 71499,
	"./pbi_trash_24.svg": 69345,
	"./pbi_trash_2_16.svg": 53102,
	"./pbi_trash_2_24.svg": 52833,
	"./pbi_trash_2_32.svg": 98110,
	"./pbi_trash_32.svg": 31498,
	"./pbi_twitter_16.svg": 26062,
	"./pbi_twitter_24.svg": 97850,
	"./pbi_twitter_32.svg": 57264,
	"./pbi_twitter_novo_16.svg": 33690,
	"./pbi_twitter_novo_24.svg": 56931,
	"./pbi_twitter_novo_32.svg": 99122,
	"./pbi_user_16.svg": 65787,
	"./pbi_user_24.svg": 68242,
	"./pbi_user_32.svg": 3422,
	"./pbi_youtube_16.svg": 46568,
	"./pbi_youtube_24.svg": 24221,
	"./pbi_youtube_32.svg": 72164,
	"./pbi_zoom_16.svg": 12920,
	"./pbi_zoom_24.svg": 75147,
	"./pbi_zoom_32.svg": 68047
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 24495;